import { useState, useEffect } from 'react';
import { Car } from '@/types/fleet';

interface UserJourney {
  viewedCars: string[];
  addViewedCar: (carTitle: string) => void;
  clearJourney: () => void;
}

export const useUserJourney = (): UserJourney => {
  const [viewedCars, setViewedCars] = useState<string[]>([]);

  useEffect(() => {
    // Load from sessionStorage on mount
    const stored = sessionStorage.getItem('viewedCars');
    if (stored) {
      try {
        setViewedCars(JSON.parse(stored));
      } catch (e) {
        console.error('Failed to parse viewed cars', e);
      }
    }
  }, []);

  const addViewedCar = (carTitle: string) => {
    setViewedCars(prev => {
      const updated = prev.includes(carTitle) ? prev : [...prev, carTitle];
      sessionStorage.setItem('viewedCars', JSON.stringify(updated));
      return updated;
    });
  };

  const clearJourney = () => {
    setViewedCars([]);
    sessionStorage.removeItem('viewedCars');
  };

  return { viewedCars, addViewedCar, clearJourney };
};
